"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargePayDto = void 0;
const billing_api_payment_intent_dto_1 = require("../../../billing-api-payment/types/dtos/billing-api-payment-intent.dto");
/**
 * Запрос на оплату начисления
 */
class BillingApiChargePayDto extends billing_api_payment_intent_dto_1.BillingApiPaymentIntentAbstractDto {
  constructor() {
    super();
  }
}
exports.BillingApiChargePayDto = BillingApiChargePayDto;
